import React from 'react';
import DevicesContainer from './DevicesContainer';
import PrivatePageHOC from '../../containers/PrivatPageHOC/PrivatePageHOC';

const Devices = () => <DevicesContainer />;

export default PrivatePageHOC(Devices);
